import { render, staticRenderFns } from "./signsCheck.vue?vue&type=template&id=82cc2b94&scoped=true"
import script from "./signsCheck.vue?vue&type=script&lang=js"
export * from "./signsCheck.vue?vue&type=script&lang=js"
import style0 from "./signsCheck.vue?vue&type=style&index=0&id=82cc2b94&prod&scoped=true&lang=css"
import style1 from "./signsCheck.vue?vue&type=style&index=1&id=82cc2b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cc2b94",
  null
  
)

export default component.exports